import * as $ from 'jquery';
import * as _ from 'underscore';

import Review from '../models/Review';

export default class ReviewRepository {

    findRandom(): JQueryPromise<Review> {
        return $.get('/dist/reviews.json').
                 then( data => Review.bless(_.sample(data)) );
    }

}



/** WEBPACK FOOTER **
 ** ./src/repositories/ReviewRepository.ts
 **/